
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whistleblowing-policy",
      function () {
        return require("private-next-pages/whistleblowing-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whistleblowing-policy"])
      });
    }
  